import { render, staticRenderFns } from "./ExcTextWithDots.vue?vue&type=template&id=f678236c&scoped=true&"
import script from "./ExcTextWithDots.vue?vue&type=script&lang=ts&"
export * from "./ExcTextWithDots.vue?vue&type=script&lang=ts&"
import style0 from "./ExcTextWithDots.vue?vue&type=style&index=0&id=f678236c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f678236c",
  null
  
)

export default component.exports